// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Text = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Text.bs.js");
var Log$SmartcutsMacros = require("./Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var RegExUtils$SmartcutsMacros = require("../../bs-utils/src/RegExUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var DOM__DataTransfer$SmartcutsMacros = require("./DOM__DataTransfer.bs.js");
var Selection__Snapshot$SmartcutsMacros = require("./Selection/Selection__Snapshot.bs.js");
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = require("./Selection/Selection__ContentEditableSelectionOrCursor.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "startIndex",
                Decco.intToJson(v.startIndex)
              ],
              [
                "endIndex",
                Decco.intToJson(v.endIndex)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var startIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startIndex"), null));
  if (startIndex.TAG === /* Ok */0) {
    var endIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endIndex"), null));
    if (endIndex.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                startIndex: startIndex._0,
                endIndex: endIndex._0
              }
            };
    }
    var e = endIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".endIndex" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = startIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".startIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function adjustByOffset(offset, param) {
  return {
          startIndex: param.startIndex + offset | 0,
          endIndex: param.endIndex + offset | 0
        };
}

function containsIndex(index, param) {
  if (param.startIndex <= index) {
    return index <= param.endIndex;
  } else {
    return false;
  }
}

function length(param) {
  return (param.endIndex - param.startIndex | 0) + 1 | 0;
}

var ContentEditableInnerTextPosition = {
  t_encode: t_encode,
  t_decode: t_decode,
  adjustByOffset: adjustByOffset,
  containsIndex: containsIndex,
  length: length
};

var t_encode$1 = t_encode;

var t_decode$1 = t_decode;

function fromCanonicalNewLineCountAndRawNewLineCount(startIndex, canonical, raw) {
  var newLinesPerCanonicalNewLine = Caml_int32.div(raw, canonical);
  return Belt_Array.mapWithIndex(Caml_array.make(canonical, 0), (function (i, param) {
                var match = i === (canonical - 1 | 0);
                var match$1 = Caml_int32.mod_(raw, canonical);
                return {
                        startIndex: startIndex + Math.imul(i, newLinesPerCanonicalNewLine) | 0,
                        endIndex: ((startIndex + Math.imul(i, newLinesPerCanonicalNewLine) | 0) + (
                            match && match$1 !== 0 ? match$1 : newLinesPerCanonicalNewLine
                          ) | 0) - 1 | 0
                      };
              }));
}

function fromExpectedEntersAndString(expectedEnters, str) {
  var actualNumNewLines = StringUtils$SmartcutsMacros.countNewLines(str);
  if (expectedEnters > 0) {
    var newLinesPerCanonicalNewLine = Caml_int32.div(actualNumNewLines, expectedEnters);
    Curry._2(Log$SmartcutsMacros.recordingContentEditing.warn2, "newLinesPerCanonicalNewLine", newLinesPerCanonicalNewLine);
    if (StringUtils$SmartcutsMacros.isComposedOfJustNewLines(str)) {
      return fromCanonicalNewLineCountAndRawNewLineCount(0, expectedEnters, actualNumNewLines);
    }
    if (newLinesPerCanonicalNewLine === 0) {
      return [];
    }
    var re = RegExUtils$SmartcutsMacros.makeNewLinesRegex("g", newLinesPerCanonicalNewLine);
    var index = str.search(re);
    if (index !== -1) {
      Curry._2(Log$SmartcutsMacros.recordingContentEditing.warn2, "index", index);
      return $$Array.append([{
                    startIndex: index,
                    endIndex: (index + newLinesPerCanonicalNewLine | 0) - 1 | 0
                  }], fromExpectedEntersAndString(expectedEnters - newLinesPerCanonicalNewLine | 0, str.slice(index + newLinesPerCanonicalNewLine | 0)));
    } else {
      return [];
    }
  }
  var index$1 = str.search(RegExUtils$SmartcutsMacros.newLineRe);
  if (index$1 !== -1) {
    return $$Array.append([{
                  startIndex: index$1,
                  endIndex: index$1
                }], fromExpectedEntersAndString(expectedEnters, str.slice(index$1 + 1 | 0)));
  } else {
    return [];
  }
}

function fromCanonicalValueAndRawValue(_startIndexOpt, _canonical, _raw) {
  while(true) {
    var startIndexOpt = _startIndexOpt;
    var raw = _raw;
    var canonical = _canonical;
    var startIndex = startIndexOpt !== undefined ? startIndexOpt : 0;
    var match = canonical.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
    var match$1 = raw.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
    if (match === -1) {
      if (match$1 !== -1) {
        console.warn("Expected canonical value to have at least 1 newline if raw value has a newline");
        return [];
      } else {
        return [];
      }
    }
    if (match === 0 && match$1 === 0) {
      var match$2 = canonical.search(RegExUtils$SmartcutsMacros.newLineRe);
      var match$3 = raw.search(RegExUtils$SmartcutsMacros.newLineRe);
      var exit = 0;
      if (match$2 !== match$3) {
        console.warn("Expected first newline to be at same position");
        return [];
      }
      if (match$2 !== -1) {
        exit = 2;
      } else {
        if (match$3 === -1) {
          return [];
        }
        exit = 2;
      }
      if (exit === 2) {
        _raw = raw.slice(match$3);
        _canonical = canonical.slice(match$2);
        _startIndexOpt = match$2;
        continue ;
      }
      
    }
    if (match$1 !== -1) {
      return $$Array.append(fromCanonicalNewLineCountAndRawNewLineCount(startIndex, match + 1 | 0, match$1 + 1 | 0), fromCanonicalValueAndRawValue(match$1, canonical.slice(match), raw.slice(match$1)));
    } else {
      console.warn("Expected raw value to have at least 1 newline if canonical value has a newline");
      return [];
    }
  };
}

function fromString(offsetOpt, str) {
  var offset = offsetOpt !== undefined ? offsetOpt : 0;
  if (offset === 0 && str === "\n") {
    return [];
  }
  var startIndex = str.search(RegExUtils$SmartcutsMacros.newLineRe);
  if (startIndex === -1) {
    return [];
  }
  var str2 = str.slice(startIndex);
  var onePastEndIndex = str2.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
  if (onePastEndIndex === -1) {
    return [{
              startIndex: startIndex + offset | 0,
              endIndex: (offset + str.length | 0) - 1 | 0
            }];
  }
  var advance = startIndex + onePastEndIndex | 0;
  return $$Array.append([{
                startIndex: offset + startIndex | 0,
                endIndex: ((offset + startIndex | 0) + onePastEndIndex | 0) - 1 | 0
              }], fromString(offset + advance | 0, str.slice(advance)));
}

function fromString$1(offsetOpt, s) {
  var offset = offsetOpt !== undefined ? offsetOpt : 0;
  var match = s.search(RegExUtils$SmartcutsMacros.nonNewLineRe);
  var match$1 = s.search(RegExUtils$SmartcutsMacros.newLineRe);
  if (match !== -1) {
    if (match === 0 && match$1 === -1) {
      return [{
                TAG: /* Text */0,
                _0: s
              }];
    }
    
  } else {
    if (match$1 === -1) {
      return [];
    }
    if (match$1 === 0) {
      return [{
                TAG: /* NewLineGroup */1,
                _0: offset + 0 | 0,
                _1: s.length
              }];
    }
    
  }
  if (match$1 === 0) {
    return $$Array.append([{
                  TAG: /* NewLineGroup */1,
                  _0: offset + 0 | 0,
                  _1: match
                }], fromString$1(offset + match | 0, s.slice(match)));
  }
  if (match !== 0) {
    return [];
  }
  var func = function (param, param$1) {
    return param$1.slice(0, param);
  };
  return $$Array.append([{
                TAG: /* Text */0,
                _0: Curry._2(func, match$1, s)
              }], fromString$1(offset + match$1 | 0, s.slice(match$1)));
}

var TextOrNewLineGroup = {
  fromString: fromString$1
};

function isTagBlock(tagName) {
  switch (tagName) {
    case "DIV" :
    case "P" :
        return true;
    default:
      return false;
  }
}

function fromNodesAndState(alreadySeenBreakOrText, openedBlockStatus, nodes) {
  return Belt_Array.reduceWithIndex(nodes, [
              [],
              openedBlockStatus,
              alreadySeenBreakOrText
            ], (function (param, node, index) {
                var alreadySeenBreakOrText = param[2];
                var openedBlockStatus = param[1];
                var textsOrNewLines = param[0];
                var element = Webapi__Dom__Element.ofNode(node);
                if (element !== undefined) {
                  var element$1 = Caml_option.valFromOption(element);
                  var tagName = element$1.tagName;
                  if (tagName === "BR") {
                    var updatedTextsOrNewLines = $$Array.append(textsOrNewLines, openedBlockStatus !== 1 ? (
                            openedBlockStatus !== 0 ? [/* NewLine */0] : (
                                index === (nodes.length - 1 | 0) ? (
                                    alreadySeenBreakOrText ? [/* NewLine */0] : []
                                  ) : []
                              )
                          ) : (
                            alreadySeenBreakOrText ? [/* NewLine */0] : []
                          ));
                    return [
                            updatedTextsOrNewLines,
                            openedBlockStatus !== 0 ? /* OpenedBlockAndBreakWasSeenInside */2 : /* NoBlockOpened */0,
                            /* HasSeenBreakOrText */1
                          ];
                  }
                  var match = fromNodesAndState(alreadySeenBreakOrText, isTagBlock(tagName) ? /* OpenedBlockAndWaitingForTextOrBreak */1 : openedBlockStatus, Array.prototype.slice.call(element$1.childNodes));
                  var updatedTextsOrNewLines$1 = $$Array.append(textsOrNewLines, match[0]);
                  return [
                          updatedTextsOrNewLines$1,
                          match[1],
                          match[2]
                        ];
                }
                var textNode = Webapi__Dom__Text.ofNode(node);
                if (textNode !== undefined) {
                  var text = Caml_option.valFromOption(textNode).data;
                  var updatedTextsOrNewLines$2 = $$Array.append(textsOrNewLines, openedBlockStatus !== 1 ? [/* Text */{
                            _0: text
                          }] : (
                          alreadySeenBreakOrText ? [
                              /* NewLine */0,
                              /* Text */{
                                _0: text
                              }
                            ] : (
                              textsOrNewLines.length === 0 ? [/* Text */{
                                    _0: text
                                  }] : [
                                  /* NewLine */0,
                                  /* Text */{
                                    _0: text
                                  }
                                ]
                            )
                        ));
                  return [
                          updatedTextsOrNewLines$2,
                          openedBlockStatus !== 0 ? /* OpenedBlockAndTextWasSeenInside */3 : /* NoBlockOpened */0,
                          /* HasSeenBreakOrText */1
                        ];
                }
                console.warn("Unhandled Dom node type", Webapi__Dom__Node.nodeType(node));
                return [
                        textsOrNewLines,
                        openedBlockStatus,
                        alreadySeenBreakOrText
                      ];
              }));
}

function fromNodes(nodes) {
  return fromNodesAndState(/* HasNotSeenBreakOrTextYet */0, /* NoBlockOpened */0, nodes)[0];
}

function arrayToTextsAndNewLineGroups(textOrNewLines) {
  return Belt_Array.reduce(textOrNewLines, [
                undefined,
                0,
                []
              ], (function (param, textOrNewLine) {
                  var newLineGroups = param[2];
                  var offset = param[1];
                  var lastSeen = param[0];
                  var match;
                  if (lastSeen !== undefined) {
                    if (lastSeen) {
                      if (textOrNewLine) {
                        var textB = textOrNewLine._0;
                        var lastIndex = newLineGroups.length - 1 | 0;
                        var match$1 = Belt_Array.get(newLineGroups, lastIndex);
                        match = match$1 !== undefined && match$1.TAG === /* Text */0 ? [
                            $$Array.append(Belt_Array.slice(newLineGroups, 0, lastIndex), [{
                                    TAG: /* Text */0,
                                    _0: match$1._0 + textB
                                  }]),
                            offset + textB.length | 0
                          ] : [
                            newLineGroups,
                            offset
                          ];
                      } else {
                        match = [
                          $$Array.append(newLineGroups, [{
                                  TAG: /* NewLineGroup */1,
                                  _0: 0,
                                  _1: 1
                                }]),
                          offset + 1 | 0
                        ];
                      }
                    } else if (textOrNewLine) {
                      var text = textOrNewLine._0;
                      match = [
                        $$Array.append(newLineGroups, [{
                                TAG: /* Text */0,
                                _0: text
                              }]),
                        offset + text.length | 0
                      ];
                    } else {
                      var lastIndex$1 = newLineGroups.length - 1 | 0;
                      var match$2 = Belt_Array.get(newLineGroups, lastIndex$1);
                      if (match$2 !== undefined && match$2.TAG !== /* Text */0) {
                        var offset$1 = match$2._0;
                        match = [
                          $$Array.append(Belt_Array.slice(newLineGroups, 0, lastIndex$1), [{
                                  TAG: /* NewLineGroup */1,
                                  _0: offset$1,
                                  _1: match$2._1 + 1 | 0
                                }]),
                          offset$1 + 1 | 0
                        ];
                      } else {
                        match = [
                          newLineGroups,
                          offset
                        ];
                      }
                    }
                  } else if (textOrNewLine) {
                    var text$1 = textOrNewLine._0;
                    match = [
                      [{
                          TAG: /* Text */0,
                          _0: text$1
                        }],
                      text$1.length
                    ];
                  } else {
                    match = [
                      [{
                          TAG: /* NewLineGroup */1,
                          _0: 0,
                          _1: 1
                        }],
                      1
                    ];
                  }
                  return [
                          textOrNewLine,
                          match[1],
                          match[0]
                        ];
                }))[2];
}

var TextOrNewLine = {
  fromNodes: fromNodes,
  arrayToTextsAndNewLineGroups: arrayToTextsAndNewLineGroups
};

function fromNodesAndInnerText(nodes, innerText) {
  var rawTextsAndNewLineGroups = fromString$1(undefined, innerText);
  var textsAndNewLines = fromNodes(nodes);
  var canonicalTextsAndNewLineGroups = arrayToTextsAndNewLineGroups(textsAndNewLines);
  return Belt_Array.concatMany(ArrayUtils$SmartcutsMacros.filterMap((function (x) {
                    return x;
                  }), Belt_Array.zipBy(canonicalTextsAndNewLineGroups, rawTextsAndNewLineGroups, (function (canonicalTextOrNewLineGroup, rawTextOrNewLineGroup) {
                        if (canonicalTextOrNewLineGroup.TAG === /* Text */0) {
                          if (rawTextOrNewLineGroup.TAG === /* Text */0) {
                            return ;
                          } else {
                            return Util$SmartcutsMacros.logAndRaiseJsError("Texts and NewLineGroups must match");
                          }
                        }
                        var canonicalCount = canonicalTextOrNewLineGroup._1;
                        if (rawTextOrNewLineGroup.TAG === /* Text */0) {
                          return Util$SmartcutsMacros.logAndRaiseJsError("Texts and NewLineGroups must match");
                        }
                        var rawCount = rawTextOrNewLineGroup._1;
                        var offset = rawTextOrNewLineGroup._0;
                        var rawNewLinesPerRegularCanonicalNewLine = Caml_int32.div(rawCount, canonicalCount);
                        var rawNewLinesPerIrregularCanonicalNewLine = Caml_int32.mod_(rawCount, canonicalCount);
                        var numRegularCanonicalNewLines = rawNewLinesPerIrregularCanonicalNewLine === 0 ? canonicalCount : canonicalCount - 1 | 0;
                        var numIrregularCanonicalNewLines = rawNewLinesPerIrregularCanonicalNewLine === 0 ? 0 : 1;
                        return $$Array.append($$Array.mapi((function (i, param) {
                                          return {
                                                  startIndex: offset + Math.imul(i, rawNewLinesPerRegularCanonicalNewLine) | 0,
                                                  endIndex: (offset + Math.imul(i + 1 | 0, rawNewLinesPerRegularCanonicalNewLine) | 0) - 1 | 0
                                                };
                                        }), Caml_array.make(numRegularCanonicalNewLines, 0)), numIrregularCanonicalNewLines === 0 ? [] : [{
                                        startIndex: offset + Math.imul(numRegularCanonicalNewLines, rawNewLinesPerRegularCanonicalNewLine) | 0,
                                        endIndex: (offset + Math.imul(numRegularCanonicalNewLines, rawNewLinesPerRegularCanonicalNewLine) | 0) + rawNewLinesPerIrregularCanonicalNewLine | 0
                                      }]);
                      }))));
}

function fromElementAndInnerText(element, innerText) {
  var nodes = Array.prototype.slice.call(element.childNodes);
  return fromNodesAndInnerText(nodes, innerText);
}

function applyToString(str, newLines) {
  return Belt_Array.reduceReverse(newLines, str, (function (canonicalStr, param) {
                return canonicalStr.slice(0, param.startIndex) + ("\n" + canonicalStr.slice(param.endIndex + 1 | 0));
              }));
}

var CanonicalNewLine = {
  ContentEditableInnerTextPosition: ContentEditableInnerTextPosition,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromExpectedEntersAndString: fromExpectedEntersAndString,
  fromCanonicalValueAndRawValue: fromCanonicalValueAndRawValue,
  fromString: fromString,
  TextOrNewLineGroup: TextOrNewLineGroup,
  TextOrNewLine: TextOrNewLine,
  fromNodesAndInnerText: fromNodesAndInnerText,
  fromElementAndInnerText: fromElementAndInnerText,
  applyToString: applyToString
};

function t_encode$2(encoder_domHtmlElement, encoder_domNode, v) {
  return Js_dict.fromArray([
              [
                "contentEditableHost",
                Curry._1(encoder_domHtmlElement, v.contentEditableHost)
              ],
              [
                "valueCanonical",
                Decco.stringToJson(v.valueCanonical)
              ],
              [
                "valueRaw",
                Decco.stringToJson(v.valueRaw)
              ],
              [
                "selection",
                Selection__Snapshot$SmartcutsMacros.Generic.t_encode(encoder_domNode, v.selection)
              ],
              [
                "expectedPaste",
                Decco.optionToJson(Decco.stringToJson, v.expectedPaste)
              ],
              [
                "expectedEnters",
                Decco.intToJson(v.expectedEnters)
              ],
              [
                "newLines",
                Decco.arrayToJson(t_encode$1, v.newLines)
              ]
            ]);
}

function t_decode$2(decoder_domHtmlElement, decoder_domNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var contentEditableHost = Curry._1(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableHost"), null));
  if (contentEditableHost.TAG === /* Ok */0) {
    var valueCanonical = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "valueCanonical"), null));
    if (valueCanonical.TAG === /* Ok */0) {
      var valueRaw = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "valueRaw"), null));
      if (valueRaw.TAG === /* Ok */0) {
        var selection = Selection__Snapshot$SmartcutsMacros.Generic.t_decode(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selection"), null));
        if (selection.TAG === /* Ok */0) {
          var expectedPaste = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectedPaste"), null));
          if (expectedPaste.TAG === /* Ok */0) {
            var expectedEnters = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectedEnters"), null));
            if (expectedEnters.TAG === /* Ok */0) {
              var newLines = Decco.arrayFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "newLines"), null));
              if (newLines.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          contentEditableHost: contentEditableHost._0,
                          valueCanonical: valueCanonical._0,
                          valueRaw: valueRaw._0,
                          selection: selection._0,
                          expectedPaste: expectedPaste._0,
                          expectedEnters: expectedEnters._0,
                          newLines: newLines._0
                        }
                      };
              }
              var e = newLines._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".newLines" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = expectedEnters._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".expectedEnters" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = expectedPaste._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".expectedPaste" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = selection._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".selection" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = valueRaw._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".valueRaw" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = valueCanonical._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".valueCanonical" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = contentEditableHost._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".contentEditableHost" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function stringify(stringifyDomHtmlElement, stringifyDomNode, param) {
  return "{contentEditableHost: " + (Curry._1(stringifyDomHtmlElement, param.contentEditableHost) + (", valueCanonical: " + (param.valueCanonical + (", selection: " + (Selection__Snapshot$SmartcutsMacros.Generic.stringify(stringifyDomNode, param.selection) + (", expectedPaste: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.expectedPaste, StringUtils$SmartcutsMacros.quote)) + (", expectedEnters: " + (String(param.expectedEnters) + "}")))))))));
}

function map(mapDomHtmlElement, mapDomNode, v) {
  return {
          contentEditableHost: Curry._1(mapDomHtmlElement, v.contentEditableHost),
          valueCanonical: v.valueCanonical,
          valueRaw: v.valueRaw,
          selection: Selection__Snapshot$SmartcutsMacros.Generic.map(mapDomNode, v.selection),
          expectedPaste: v.expectedPaste,
          expectedEnters: v.expectedEnters,
          newLines: v.newLines
        };
}

var Generic = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify,
  map: map
};

function updateWithDomEvent(domElementIdentifierGenerator, domEvent, vContentEditable) {
  switch (domEvent.TAG | 0) {
    case /* ClipboardEvent */3 :
        if (domEvent._0 !== "paste") {
          return vContentEditable;
        }
        var data = domEvent._1.clipboardData;
        var pastedText = DOM__DataTransfer$SmartcutsMacros.getData("text", data);
        var contentEditableHost = vContentEditable.contentEditableHost;
        var valueBeforePaste = contentEditableHost.innerText;
        var selection = Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined);
        var selectionOrCursor = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.fromSelectionSnapshot(domElementIdentifierGenerator, selection);
        var valueAfterPaste;
        if (typeof selectionOrCursor === "number") {
          valueAfterPaste = valueBeforePaste;
        } else if (selectionOrCursor.TAG === /* ContentEditableSelection */0) {
          var nonInputSelection = selectionOrCursor._1;
          var exit = 0;
          var selectedText;
          if (nonInputSelection.TAG === /* SingleNode */0) {
            selectedText = nonInputSelection._0.selectedText;
            exit = 1;
          } else {
            selectedText = nonInputSelection._0.selectedText;
            exit = 1;
          }
          if (exit === 1) {
            valueAfterPaste = StringUtils$SmartcutsMacros.slice(valueBeforePaste.indexOf(selectedText), selectedText.length, StringUtils$SmartcutsMacros.slice(0, valueBeforePaste.indexOf(selectedText), valueBeforePaste) + (pastedText + valueBeforePaste));
          }
          
        } else {
          var _contentEditableCursor = selectionOrCursor._1;
          var offset = _contentEditableCursor.offset;
          var textNodeIndex = _contentEditableCursor.textNodeIndex;
          var domElementIdentifier = _contentEditableCursor.domElementRepresentation.domElementIdentifier;
          var enterToken = "\n";
          valueAfterPaste = Belt_List.reduce(_contentEditableCursor.textContents, "", (function (str, textContent) {
                  if (textContent.TAG === /* TextSegment */0) {
                    var currElement = textContent._0;
                    if (currElement.TAG !== /* NonEmptySegment */0) {
                      if (currElement._0.domElementIdentifier === domElementIdentifier) {
                        return str + pastedText;
                      } else {
                        return str;
                      }
                    }
                    var match = currElement._0;
                    var text = match.text;
                    if (match.textNodeIndex === textNodeIndex) {
                      return str + (StringUtils$SmartcutsMacros.slice(0, offset, text) + (pastedText + StringUtils$SmartcutsMacros.slice(offset, text.length, text)));
                    } else {
                      return str + text;
                    }
                  }
                  var currElement$1 = textContent._0;
                  if (currElement$1.TAG !== /* NonEmptySegment */0) {
                    if (currElement$1._0.domElementIdentifier === domElementIdentifier) {
                      return str + (enterToken + pastedText);
                    } else {
                      return str + enterToken;
                    }
                  }
                  var match$1 = currElement$1._0;
                  var text$1 = match$1.text;
                  if (match$1.parentElement.domElementIdentifier === domElementIdentifier && textNodeIndex === -1) {
                    return str + (enterToken + (text$1 + pastedText));
                  } else {
                    return str + (enterToken + text$1);
                  }
                }));
        }
        return {
                contentEditableHost: vContentEditable.contentEditableHost,
                valueCanonical: valueAfterPaste,
                valueRaw: valueAfterPaste,
                selection: selection,
                expectedPaste: pastedText,
                expectedEnters: vContentEditable.expectedEnters,
                newLines: vContentEditable.newLines
              };
        break;
    case /* Event */9 :
        if (domEvent._0 === "selectionchange") {
          return {
                  contentEditableHost: vContentEditable.contentEditableHost,
                  valueCanonical: vContentEditable.valueCanonical,
                  valueRaw: vContentEditable.valueRaw,
                  selection: Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined),
                  expectedPaste: vContentEditable.expectedPaste,
                  expectedEnters: vContentEditable.expectedEnters,
                  newLines: vContentEditable.newLines
                };
        } else {
          return vContentEditable;
        }
    default:
      return vContentEditable;
  }
}

function make(contentEditableHost) {
  var valueRaw = contentEditableHost.innerText;
  var newLines = fromElementAndInnerText(contentEditableHost, valueRaw);
  var valueCanonical = StringUtils$SmartcutsMacros.replaceNonBreakingSpacesWithSpaces(applyToString(valueRaw, newLines));
  var selectionSnapshot = Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined);
  return {
          contentEditableHost: contentEditableHost,
          valueCanonical: valueCanonical,
          valueRaw: valueRaw,
          selection: selectionSnapshot,
          expectedPaste: undefined,
          expectedEnters: 0,
          newLines: newLines
        };
}

function refreshValueAndSelection(vContentEditable) {
  var contentEditableHost = vContentEditable.contentEditableHost;
  var valueRaw = contentEditableHost.innerText;
  var updatedNewLines = fromElementAndInnerText(contentEditableHost, valueRaw);
  var valueCanonical = StringUtils$SmartcutsMacros.replaceNonBreakingSpacesWithSpaces(StringUtils$SmartcutsMacros.replaceAll(StringUtils$SmartcutsMacros.nbsp, " ", applyToString(valueRaw, updatedNewLines)));
  Curry._4(Log$SmartcutsMacros.recordingContentEditing.warn4, "new canonical value + updatedNewLines", StringUtils$SmartcutsMacros.quote(valueCanonical), StringUtils$SmartcutsMacros.quote(valueRaw), updatedNewLines);
  return {
          contentEditableHost: vContentEditable.contentEditableHost,
          valueCanonical: valueCanonical,
          valueRaw: valueRaw,
          selection: Selection__Snapshot$SmartcutsMacros.Regular.capture(undefined),
          expectedPaste: undefined,
          expectedEnters: 0,
          newLines: updatedNewLines
        };
}

var Regular = {
  updateWithDomEvent: updateWithDomEvent,
  make: make,
  refreshValueAndSelection: refreshValueAndSelection
};

var ForSerialization = {};

exports.CanonicalNewLine = CanonicalNewLine;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* Webapi__Dom__Node Not a pure module */
